module.exports = __webpack_public_path__ + "img/38953-063.0bb4f89d.jpg";